import styled from "styled-components";
import { iconClose } from "assets/icons";
import BTModal from "react-bootstrap/Modal";

export const ModalContainer = styled(BTModal)`
  .modal-content {
    background: ${({ theme }) => theme.modal.bg.primary};
    margin: 0 auto;
    padding: 12px;
    border: 2px solid ${({ theme }) => theme.modal.border.color};
    border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_10};

    .modal-header {
      border: 0;
      .body-heading {
        font-weight: 400;
        font-size: 16px;
        text-align: center;
        color: ${({ theme }) => theme.global.color.bodyColor};
      }
    }

    .btn-close {
      background: #181d27;
      -webkit-mask: url("${iconClose}") center/1em auto no-repeat;
      mask: url("${iconClose}") center/1em auto no-repeat;
      position: absolute;
      right: 16.8px;
      top: 16.8px;
      opacity: 1;
      outline: none;
      z-index: 1;

      &:hover {
        opacity: 0.7;
      }
      &:focus {
        box-shadow: none;
      }
    }

    .modal-body {
      margin-top: 10px;
      padding-top: 0;
    }
  }
`;
